import React, { useState, useEffect } from 'react';
import {
  Card,
  Justify,
  Segment,
} from "tea-component";
import moment from "moment";
import ExploreEchart from '@/pages/home/pages/home/components/ExploreEchart';
import ExploreTable from '@/pages/home/pages/home/components/ExploreTable';
import { getGameListFromDashboard, getRainbowApi } from '@/pages/home/services/home';
import { useIntl, useSelector, shallowEqual } from 'umi';
import Abnormal from '@/pages/home/components/Abnormal';
import { transTableAsNewTabCBTothers, timeFormat, sortPermissionList } from '../_config/common';
import { ACCESS_LINK, IS_GLOBAL } from '@/pages/home/_config/config';
import { ORGANIZATION_FUN, DEMO_GAME_LIST } from '@/pages/dashboard/_config/constant';

export default function GlobalGames(props: any) {
  const { formatMessage } = useIntl() // 中英切换方法
  const [segVal, setSegVal] = useState('dau');
  const [chartData, setChartData] = useState([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [timeVal, setTimeVal] = useState('');
  const [timeType, setTimeType] = useState('last');
  const [loadingCharts, setLoadingCharts] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState<any[]>([]);
  const [chartRealData, setChartRealData] = useState([]);
  const MAXSELECTGAME = 10;
  const [dashboardPageinfoList, setDashboardPageinfoList] = useState([]);

  // const [dauTipsEn, setDauTipsEn] = useState('');
  const { userInfo } = useSelector(state => {
    const { userInfo } = state.home;
    return {
      userInfo
    }
  }, shallowEqual);

  const onTabChange = (value: string) => {
    setTimeType('last');
    if (value === 'new_users') {
      setTimeType(timeType === 'last' ? 'yesterday' : 'last');
    }

    setSegVal(value);
  };

  // 只取前5并排序，，勾选表格
  const getIegDataCharts = async (chartDatas: any) => {
    try {
      const gameIdArr = chartDatas?.map((item: any) => item?.game);
      const gameIdArrInit =
        gameIdArr?.length < MAXSELECTGAME ? gameIdArr : gameIdArr.slice(0, MAXSELECTGAME);
      setSelectedKeys(gameIdArrInit);
      setChartData(chartDatas);
      const arr = chartDatas?.filter((item: any) => {
        return gameIdArrInit?.includes(item.game);
      });
      arr.sort(function (a: any, b: any) {
        return gameIdArrInit?.indexOf(a?.game) - gameIdArrInit?.indexOf(b?.game);
      });
      setChartRealData(arr);
    } catch (err) {
      console.log(err);
      setChartRealData([])
    }
  };

  const getGameList = async () => {
    // setLoadingCharts(true);
    // 兼容旧环境
    // const isOld = location.hostname === 'databrain-global.intlgame.com';
    // const fetchName = isOld ? gameListContainTable : getGameListFromDashboard;
    const fetchName = getGameListFromDashboard;
    setLoading(true);
    try {
      const resOriginal = await fetchName({
        date: "",
        days: 15,
        style_version: "v2",  //新风格此接口添加参数
        page: {
          page_no: 1,
          page_size: 40000,
        },
      })
      const res = resOriginal?.data
      let tableDatas = res?.data?.pc_home_table_game || [];
      let chartDatas = res?.data?.pc_home_game || [];

      const { organization = [] } = userInfo || {};

      if (IS_GLOBAL && organization.includes(ORGANIZATION_FUN)) {
        tableDatas = (tableDatas || []).filter(item => {
          return !DEMO_GAME_LIST.includes(item.game);
        });

        chartDatas = (chartDatas || []).filter(item => {
          return !DEMO_GAME_LIST.includes(item.game);
        });
      }
      /**之前是按last_dau排序，并将newgame,upcominggame展示在最前面，
       * 现在需求改成按dau排序
       */

      /**这块其实是给可视化排序使之与表格顺序一至， 可视化legend颜色与表格按顺序对应 */
      for (let n in chartDatas) {
        /**拿dau数据，即最新返回的一天 */
        const des2 = chartDatas[n]?.data_list?.length - 1;
        chartDatas[n].dau = chartDatas[n]?.data_list[des2]?.dau;//将对应的data_list倒数第二个的dau赋值给每个item的dau
      }

      chartDatas.sort((a: any, b: any) => b?.dau - a?.dau);
      /**默认按dau排序 */
      tableDatas = transTableAsNewTabCBTothers(tableDatas, 'release_time', 'game_phase');
      tableDatas.sort((a: any, b: any) => b?.dau - a?.dau);
      setTableData(tableDatas);
      getIegDataCharts(chartDatas);

      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }
  const handleTableCheck = (keys: any) => {
    try {
      const arr = chartData?.filter((item: any) => {
        return keys?.includes(item?.game);
      });
      arr?.sort(function (a: any, b: any) {
        return keys?.indexOf(a?.game) - keys?.indexOf(b?.game);
      });
      setChartRealData(arr);
    } catch (err) {
      console.log(err)
    }
  }
  //处理可视化颜色
  useEffect(() => {
    try {
      const arr = chartData?.filter((item: any) => {
        return selectedKeys?.includes(item?.game);
      });
      // 处理颜色
      arr.sort(function (a: any, b: any) {
        return selectedKeys?.indexOf(a?.game) - selectedKeys?.indexOf(b?.game);
      });
      setChartRealData(arr);
    } catch (err) {
      console.log(err)
    }
  }, [selectedKeys]);

  //通过七彩石接口，获取当前游戏是否有下架时间，下架时间是多少
  const getDauTip = async () => {
    try {
      const res = await getRainbowApi({
        key: '',
        group: 'dashboard.pc.pageinfo',
      });
      if (Array.isArray(res?.data?.rows)) {
        setDashboardPageinfoList(res?.data?.rows || []);
        // setDauTipsEn(arr?.find((item: any) => item.key == 'DAU')?.value || '');
        // setDauTipsCn(arr?.find((item: any) => item.key == '日活跃')?.value || '');
      }
    } catch (err) { }
  };

  useEffect(() => {
    if (!userInfo) {
      return;
    }
    getGameList();
    getDauTip();
  }, [userInfo])

  const options = [
    { text: formatMessage({ id: 'dbh_metric_dau' }), value: 'dau' },
    { text: formatMessage({ id: 'dbh_metric_revenue' }), value: 'revenue' },
    { text: formatMessage({ id: 'dbh_metric_d2' }) + '(T-1)', value: 'd2', cnWidth: 170, },
    { text: formatMessage({ id: 'dbh_metric_newusers' }), value: 'new_users' },
    { text: formatMessage({ id: 'dbh_metric_arpu' }), value: 'arpu', cnWidth: 170, },
    { text: formatMessage({ id: 'dbh_metric_arppu' }), value: 'arppu', cnWidth: 170, },
    { text: formatMessage({ id: 'dbh_metric_payer_growth' }), value: 'pay_permeability' },
    { text: formatMessage({ id: 'dbh_metric_payer' }), value: 'payer' },
    { text: formatMessage({ id: 'dbh_metric_pcu' }), value: 'pcu', cnWidth: 170, },
    { text: formatMessage({ id: 'dbh_metric_aotmin' }), value: 'aot', cnWidth: 200 },
    { text: formatMessage({ id: 'dbh_metric_tru' }), value: 'tru', cnWidth: 170, },
  ]

  return (
    <>
      <Card className='home-card'>
        <Card.Body
          title={<div className='home-card-title'>{formatMessage({ id: 'dbh_iegglobal' })}</div>}
          operation={
            <>
              {!IS_GLOBAL &&<div className='home-card-desc'>
                <a
                  href={ACCESS_LINK}
                  target="_blank" rel="noreferrer"
                >
                  {formatMessage({ id: 'dbh_getgameaccess' })}
                </a>
              </div>}
            </>
          }>

          <Abnormal
            isLoading={loading}
            isError={error}
            isNoData={!tableData?.length}
            style={{ height: 200 }}
            component={<>
              <Justify
                left={
                  <Segment
                    rimless={false}
                    value={segVal.toString()}
                    onChange={(value) => onTabChange(value)}
                    options={options}
                  />
                }
                right={
                  <div className='home-card-time'>
                    {timeType === 'last'
                      ? timeFormat(timeVal)
                      : timeFormat(moment(timeVal).subtract(1, 'd'))
                    }
                  </div>
                }
              />
              <div className='home-card-line'>
                <ExploreEchart
                  chartName={
                    options.filter((item) => item.value === segVal)[0]?.text
                  }
                  segVal={segVal}
                  chartData={sortPermissionList(chartRealData)}
                  selectedKeys={selectedKeys}
                  // chartId={segVal}
                  // timeType={timeType}
                  loading={loadingCharts}
                />
              </div>
              <ExploreTable
                tableData={tableData}
                segVal={segVal}
                options={options}
                selectedKeys={selectedKeys}
                handleTableCheck={handleTableCheck}
                maxGameNum={MAXSELECTGAME}
                dashboardPageinfoList={dashboardPageinfoList}
              // dauTipsCn={dauTipsCn}
              // dauTipsEn={dauTipsEn}
              /></>
            }
          />
        </Card.Body>
      </Card>
    </>

  );
};
